export default "__VITE_ASSET__DcCG0gyW__"